import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserDetails {
  user_id?: string;
  role?: string;
  profile_picture?: string;
  business?: { business_id?: string };
  business_link?: { business_id?: string };
  user_permissions?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface FeedbackDetailPayload {
  ticket_id?: string | number;
  business_id?: string | number;
  business_name?: string;
  subject?: string;
  description?: string;
  severity?: string;
  status?: string;
  created_at?: string;
  created?: string;
  user?: string;
  email?: string;
  attachment?: string;
  [key: string]: unknown;
}

export interface FeatureAccessState {
  selectedBusinessId: string | null;
  userDetails: UserDetails | null;
  profilePicture: string | null;
  selectedFeedbackDetails: FeedbackDetailPayload | null;
  selectedUserIdToViewDetails: string | null;
  feedbackTicketsList: Record<string, unknown>[] | null;
}

const initialState: FeatureAccessState = {
  selectedBusinessId: null,
  userDetails: null,
  profilePicture: null,
  selectedFeedbackDetails: null,
  selectedUserIdToViewDetails: null,
  feedbackTicketsList: null,
};

const featureAccessSlice = createSlice({
  name: "featureAccess",
  initialState,
  reducers: {
    setSelectedBusinessId: (state, action: PayloadAction<string | null>) => {
      state.selectedBusinessId = action.payload;
    },
    setUserDetails: (state, action: PayloadAction<UserDetails | null>) => {
      state.userDetails = action.payload;
    },
    setProfilePicture: (state, action: PayloadAction<string | null>) => {
      state.profilePicture = action.payload;
    },
    setSelectedFeedbackDetails: (state, action: PayloadAction<FeedbackDetailPayload | null>) => {
      state.selectedFeedbackDetails = action.payload;
    },
    setSelectedUserIdToViewDetails: (state, action: PayloadAction<string | null>) => {
      state.selectedUserIdToViewDetails = action.payload;
    },
    setFeedbackTicketsList: (state, action: PayloadAction<Record<string, unknown>[] | null>) => {
      state.feedbackTicketsList = action.payload;
    },
    clearFeatureAccess: () => initialState,
  },
});

export const {
  setSelectedBusinessId,
  setUserDetails,
  setProfilePicture,
  setSelectedFeedbackDetails,
  setSelectedUserIdToViewDetails,
  setFeedbackTicketsList,
  clearFeatureAccess,
} = featureAccessSlice.actions;
export default featureAccessSlice.reducer;
